
export const CURRENCIES = ['EUR', 'USD', 'JPY', 'CNY', 'GBP'];
export const LANGUAGES = ['en', 'fr', 'it', 'es'];
export const PLACEMENTS_COUNT = [10, 50, 200, 500];
export const PERIOD_MINIMUM_DATE = '2020-03-01';
